module.exports = __webpack_public_path__ + "img/no.b2ee9b05.png";